const codeConversions = {
    // General errors
    APPLICATION: {
        sv: {
            header: 'Applikationsfel',
            message: 'Ett applikationsfel har uppstått'
        },
        en: {
            header: 'Application error',
            message: 'An application error has occurred'
        }
    },
    GENERAL_COMMUNICATION: {
        sv: {
            header: 'Kommunikationsfel',
            message: 'Ett kommunikationsfel har uppstått, vänligen försök igen'
        },
        en: {
            header: 'Communication error',
            message: 'A communication error has occurred'
        }
    },

    // Writer config file

    WRITERCONFIG_BAD_REQUEST: {
        sv: {
            header: 'Konfigurationsfil för writer',
            message: 'Ett problem med att hämta konfigurationsfilen från servern har uppstått'
        },
        en: {
            header: 'Configuration file for writer',
            message: 'A problem with fetching writer config file has occurred'
        }
    },
    WRITERCONFIG_INTERNAL_SERVER_ERROR: {
        sv: {
            header: 'Serverfel vid inläsning av konfiguration',
            message: 'Ett problem har uppstått på servern vid inläsning av konfigurationsfil'
        },
        en: {
            header: 'Server error when reading config file',
            message: 'A problem with reading the config file on server has occurred'
        }
    },
    WRITERCONFIG_CLIENT_ERROR: {
        sv: {
            header: 'Fel vid inläsning av klientkonfiguration',
            message: 'Ett problem har uppstått vid inläsning av klientens konfigurationsfil'
        },
        en: {
            header: 'Error when reading client config file',
            message: 'An error occurred when reading the client configuration file'
        }
    },


    // Article

    ARTICLE_BAD_REQUEST: {
        sv: {
            header: 'Artikelproblem',
            message: 'Det uppstod ett problem att ladda artikeln'
        },
        en: {
            header: 'Article problem',
            message: 'There was a problem loading the article'
        }
    },
    ARTICLE_UNAUTHORIZED: {
        sv: {
            header: 'Ej inloggad',
            message: 'Inloggning krävs för att komma åt artikeln'
        },
        en: {
            header: 'Not logged in',
            message: 'Login is required to access the article'
        }
    },
    ARTICLE_FORBIDDEN: {
        sv: {
            header: 'Otillräckliga rättigheter',
            message: 'Artikeln kan ej laddas på grund av att rättigheter saknas'
        },
        en: {
            header: 'Authorization failed',
            message: 'The article could not be loaded due to an authorization problem'
        }
    },
    ARTICLE_NOT_FOUND: {
        sv: {
            header: 'Artikeln hittades inte',
            message: 'Artikeln kunde inte hittas'
        },
        en: {
            header: 'Article not found',
            message: 'The article could not be found'
        }
    },

}

const message = function (code, labelLanguage) {
    if (codeConversions[code]) {
        if (codeConversions[code][labelLanguage]) {
            return codeConversions[code][labelLanguage].message
        } else if (codeConversions[code]['en']) {
            return codeConversions[code]['en'].message
        }
    }

    if (codeConversions.APPLICATION[labelLanguage]) {
        return codeConversions.APPLICATION[labelLanguage].message
    }

    return codeConversions.APPLICATION.en.message
}

const header = function(code, labelLanguage) {
    if (codeConversions[code]) {
        if (codeConversions[code][labelLanguage]) {
            return codeConversions[code][labelLanguage].header
        } else if (codeConversions[code]['en']) {
            return codeConversions[code]['en'].header
        }
    }

    if (codeConversions.APPLICATION[labelLanguage]) {
        return codeConversions.APPLICATION[labelLanguage].header
    }

    return codeConversions.APPLICATION.en.header

}

export {message, header}
